import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-segmented-list',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './segmented-list.component.html',
  styleUrl: './segmented-list.component.css',
})
export class SegmentedListComponent {}
